/**
 * @prettier
 */

import * as React from 'react';
import { Editor, EditorState } from 'draft-js';

export const SET_EDITOR_REF = '@@CHSEditor/SET_EDITOR_REF';
export const SET_EDITOR_STATE = '@@CHSEditor/SET_EDITOR_STATE';
export const SET_FORMATTING_TOOLTIP_CONTENT =
  '@@CHSEditor/SET_FORMATTING_TOOLTIP_CONTENT';
export const SET_LINK_INPUT = '@@CHSEditor/SET_LINK_INPUT';
export const SET_TOOLTIP = '@@CHSEditor/SET_TOOLTIP';
export const SET_ADD_TOOLTIP = '@@CHSEditor/SET_ADD_TOOLTIP';

export const setEditorRef = editorRef => ({
  type: SET_EDITOR_REF,
  editorRef,
});

export const setEditorState = editorState => ({
  type: SET_EDITOR_STATE,
  editorState,
});

export const setFormattingTooltipContent = content => ({
  type: SET_FORMATTING_TOOLTIP_CONTENT,
  content,
});

export const setTooltip = tooltip => ({
  type: SET_TOOLTIP,
  tooltip,
});

export const setAddTooltip = addTooltip => ({
  type: SET_ADD_TOOLTIP,
  addTooltip,
});

export default {
  setAddTooltip,
  setEditorState,
  setFormattingTooltipContent,
  setTooltip,
  setEditorRef,
};
